import { personSchema } from "@/components/Forms/schema/personSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceSelector } from "jsonapi-zod-query";

const resourceSelector = createResourceSelector({
    type: "person",
    attributesSchema: personSchema,
});

export type Person = ReturnType<typeof resourceSelector>;

type Props = {
    isQueryEnabled: boolean;
    personUUID: string;
};
export const useFetchPersonByUUID = ({
    isQueryEnabled,
    personUUID,
}: Props): UseQueryResult<Person> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        enabled: isQueryEnabled,
        queryKey: ["person-uuid", { personUUID }],
        queryFn: async ({ signal }) => {
            const url = apiUrl(`/person/by-uuid/${personUUID}`);

            const response = await fetch(url, {
                signal,
                headers: {
                    accept: "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: resourceSelector,
    });
};
